import { SetStateAction } from 'react'
import { isValidNumber } from 'libphonenumber-js'

interface IvaildatePhone {
  phone?: string
  setPhoneError?: (value: SetStateAction<string>) => void
  required?: boolean
}
export const useValidatePhone = (): {
  validatePhone: ({ phone, setPhoneError, required }: IvaildatePhone) => boolean
} => {
  const validatePhone = ({
    phone,
    setPhoneError,
    required = true,
  }: IvaildatePhone) => {
    if (!phone) {
      setPhoneError?.(required ? 'Phone number is required' : '')
      return !required
    }

    if (!isValidNumber(phone)) {
      setPhoneError?.('Invalid phone number')
      return false
    }

    setPhoneError?.('')
    return true
  }
  return { validatePhone }
}
